module.exports = __webpack_public_path__ + "static/media/link.60d149d2.svg";